/* eslint-disable max-len */
export default {
  'Web.time': 'Uhr',
  'Web.U2UpLimit': 'Spannungssteigerungsschutz U>>',
  'Web.UUpAve': 'Spannungssteigerungsschutz U>',
  'Web.U1LoLimit': 'Spannungsrückgangsschutz U<',
  'Web.U2LoLimit': 'Spannungsrückgangsschutz U<<',
  'Web.F1LoLimit': 'Frequenzrückgangsschutz f<',
  'Web.F1UpLimit': 'Frequenzsteigetungsschutz f>',
  'Web.PUtype': 'Spannungsabhängige Wirkleistungsreduzierung P(U) ',
  'Web.ProductionData': 'Seriennummer Leistungselektronik ',
  'Web.Buttons.Save': 'Speichern',
  'Web.ChangePassword.Buttons.ChangePassword': 'Neues Passwort setzen',
  'Web.ChangePassword.CurrentPassword': 'Altes Passwort',
  'Web.ChangePassword.Input.OldPassword': 'Geben Sie bitte ihr bisheriges Passwort ein.',
  'Web.ChangePassword.Messages.Failure': 'Ihr Passwort konnte nicht geändert werden.',
  'Web.ChangePassword.Messages.Success': 'Ihr Passwort wurde erfolgreich geändert.',
  'Web.ChangePassword.NewPassword': 'Passwort',
  'Web.ChangePassword.RepeatPassword': 'Passwort wiederholen',
  'Web.ChangePassword.Text':
    'Bitte geben Sie Ihr altes Passwort ein, um es zu ändern und durch ein neues Passwort zu ersetzen.',
  'Web.ChangePassword.Title': 'Passwort ändern',
  'Web.device_selection_title': 'Systemliste',
  'Web.Device.List.Placeholder': 'Geben Sie Ihren Suchbegriff ein...',
  'Web.EditProfile.ChangePassword': 'Passwort ändern',
  'Web.EditProfile.FirstName': 'Name',
  'Web.EditProfile.LastName': 'Nachname',
  'Web.EditProfile.Location': 'System Standort',
  'Web.EditProfile.Street': 'Straße und Hausnr.',
  'Web.EditProfile.Zip': 'Postleitzahl und Wohnort',
  'Web.EditProfile.PostalCode': 'Postleitzahl',
  'Web.EditProfile.Town': 'Wohnort',
  'Web.EditProfile.Country': 'Land',
  'Web.EditProfile.PhoneNumber': 'Telefonnummer',
  'Web.Errors.Fatal.Device.Message':
    'Es konnte leider keine Ihnen zugewiesene Smart Battery gefunden werden. Gerne helfen wir Ihnen das zu klären.',
  'Web.Errors.Fatal.Device.Title': 'Kein System gefunden!',
  'Web.Errors.Input.Attempts':
    'Zu viele Versuche. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
  'Web.Errors.Login': 'Ihre Daten stimmen nicht überein. <br>Bitte versuchen Sie es erneut.',
  'Web.expert_view_battery_inverter_charging_current': 'Ladestrom',
  'Web.expert_view_battery_inverter_charging_power': 'Ladeleistung',
  'Web.expert_view_battery_inverter_cos_current': 'Cos(φ) aktuell',
  'Web.expert_view_battery_inverter_discharging': 'Entladeleistung',
  'Web.expert_view_battery_inverter_discharging_current': 'Entladestrom',
  'Web.expert_view_battery_inverter_lower_limit': 'Unteres Limit',
  'Web.expert_view_battery_inverter_lower_limit_max': 'Unteres Limit max.',
  'Web.expert_view_battery_inverter_lower_limit_min': 'Unteres Limit min.',
  'Web.expert_view_battery_inverter_performance_set_point': 'Leistung Setpoint',
  'Web.expert_view_battery_inverter_performance_discharge_set_point': 'Entladeleistung Setpoint',
  'Web.expert_view_battery_inverter_performance_charge_set_point': 'Ladeleistung Setpoint',
  'Web.expert_view_battery_inverter_voltage_max': 'Max. Spannung',
  'Web.expert_view_battery_inverter_voltage_min': 'Min. Spannung',
  'Web.expert_view_battery_inverter_charging_current_max': 'Max. Ladestrom',
  'Web.expert_view_battery_inverter_discharging_current_max': 'Max. Entladestrom',
  'Web.expert_view_battery_inverter_powerfactor': 'Leistungsfaktor',
  'Web.expert_view_battery_inverter_q_cr_time': 'Blindleistungs-Zeitkonstante',
  'Web.expert_view_battery_inverter_q_fix_var': 'Blindleistung',
  'Web.expert_view_battery_inverter_qmax_smax': 'Verhältnis Qmax/Smax',
  'Web.expert_view_battery_inverter_upper_limit': 'Oberes Limit',
  'Web.expert_view_battery_inverter_upper_limit_max': 'Oberes Limit max.',
  'Web.expert_view_battery_inverter_upper_limit_min': 'Oberes Limit min.',
  'Web.expert_view_battery_inverter_voltage': 'Spannung',
  'Web.expert_view_country_code_austria_d4': '0043 Österreich TOR D4',
  'Web.expert_view_country_code_austria_producer': '0043 Österreich TOR Erzeuger',
  'Web.expert_view_country_code_austria': '0043 Österreich',
  'Web.expert_view_country_code_germany': '0049 Deutschland',
  'Web.expert_view_country_code_switzerland': '0041 Schweiz',
  'Web.expert_view_d4': 'D4',
  'Web.expert_view_d5': 'D5',
  'Web.expert_view_d6': 'D6',
  'Web.expert_view_d7': 'D7',
  'Web.expert_view_error_battery': 'Batterie Fehler',
  'Web.expert_view_error_inverter': 'Inverter Fehler',
  'Web.expert_view_error_system': 'System Fehler',
  'Web.expert_view_error_title': 'Fehlercodes',
  'Web.expert_view_heat_pump_slider': 'Überschussleistung',
  'Web.expert_view_heat_pump_switch': 'Wärmepumpe über SG Ready Schnittstelle angeschlossen',
  'Web.expert_view_heat_pump_title': 'Wärmepumpe',
  'Web.expert_view_inverter_title': 'Photovoltaikanlage',
  'Web.expert_view_land_codes_title': 'Ländercode',
  'Web.expert_view_limit_setup_option_0': 'Aus',
  'Web.expert_view_limit_setup_option_1': 'Ein',
  'Web.expert_view_limit_setup_title': 'Wirkleistungsbegrenzung',
  'Web.expert_view_num_of_battery_module_title': 'Anzahl der Batteriemodule',
  'Web.expert_view_operation_mode_options_option_0': 'Eigenverbrauchs-Optimierung',
  'Web.expert_view_operation_mode_options_option_1': 'Set Point Modus',
  'Web.expert_view_operation_mode_options_option_2': 'SoC Modus',
  'Web.expert_view_operation_mode_title': 'Betriebsmodus',
  'Web.expert_view_pv_inverter_power_title': 'Leistung PV-Wechselrichter',
  'Web.expert_view_pv_power_title': 'Gesamtleistung PV-Module',
  'Web.expert_view_q_u_label_reactive_rel': 'Blindleistung Q/Sr',
  'Web.expert_view_q_u_label_voltage_rel': 'Spannung U/Un',
  'Web.expert_view_reaction_time_title': 'Reaktionszeit',
  'Web.expert_view_settings_cos_phi_for_all': 'Alle',
  'Web.expert_view_settings_cos_phi_options_at_option_0': 'Eine Stützstelle',
  'Web.expert_view_settings_cos_phi_options_at_option_1': 'Stützstellen cos(φ) (leistungsabhängig)',
  'Web.expert_view_settings_cos_phi_options_at_option_2': 'Stützstellen Q(U) (spannungsabhängig)',
  'Web.expert_view_settings_cos_phi_options_de_option_0': 'Eine Stützstelle',
  'Web.expert_view_settings_cos_phi_options_de_option_1': 'Stützstellen cos(φ) (leistungsabhängig)',
  'Web.expert_view_settings_cos_phi_title': 'Einstellwert: Cos-Phi',
  'Web.expert_view_total_power_battery': 'Smart Battery: Entladung pro Tag ∑',
  'Web.expert_view_total_power_grid_feed': 'Netz: Einspeisung ∑',
  'Web.expert_view_total_power_grid_reference': 'Netz: Bezug ∑',
  'Web.expert_view_total_power_solar_feed': 'Photovoltaik: Einspeisung ∑',
  'Web.expert_view_total_power_title': 'Gesamtenergie',
  'Web.expert_view_version_api': 'API Version:',
  'Web.expert_view_version_firmware': 'Firmware Version:',
  'Web.expert_view_version_model': 'Model Version:',
  'Web.expert_view_version_inverter_bdc': 'BDC',
  'Web.expert_view_version_inverter_ens': 'ENS',
  'Web.expert_view_version_inverter_hmi_app': 'HMI_APP',
  'Web.expert_view_version_inverter_hmi_fbl': 'HMI_FBL',
  'Web.expert_view_version_inverter_pu': 'PU',
  'Web.expert_view_save_settings_failure': 'Speichern fehlgeschlagen',
  'Web.expert_view_save_settings_success': 'Erfolgreich gespeichert',
  'Web.expert_view_save_settings': 'Eingabewerte speichern',
  'Web.expert_view_pv_inverter_ip_address': 'Inverter-IP:Port:UnitID+123',
  'Web.expert_view_inverter_type_options': 'Ansteuerung PV-Wechselrichter',
  'Web.expert_view_inverter_type_option_1': 'Standard (4 digitale Eingänge)',
  'Web.expert_view_inverter_type_option_2': 'SMA Sunny Boy (Modbus TCP)',
  'Web.ExpertMode.Buttons.Retry': 'Erneut versuchen',
  'Web.ExpertMode.Headline': 'SIEMENS Junelight',
  'Web.ExpertMode.Items.Battery.Battery': 'Batterieladung (SOC)',
  'Web.ExpertMode.Items.Battery.Cycles': 'Anzahl Zyklen',
  'Web.ExpertMode.Items.Battery.MaxCharge': 'Ladestrom: Max.',
  'Web.ExpertMode.Items.Battery.Voltage': 'Batteriespannung',
  'Web.ExpertMode.Items.Power.Consumer': 'Verbraucher',
  'Web.ExpertMode.Items.Power.Grid': 'Netz',
  'Web.ExpertMode.Items.Power.Inverter': 'Smart Battery Wechselrichter',
  'Web.ExpertMode.Items.Power.PV': 'Photovoltaik',
  'Web.ExpertMode.Items.Versions.ModelDate': 'Model Datum:',
  'Web.ExpertMode.Items.Versions.ModelName': 'Model Name:',
  'Web.ExpertMode.Items.Versions.Versions': 'Versionen',
  'Web.ExpertMode.Items.Inverter.title': 'Smart Battery Wechselrichter Versionen',
  'Web.ExpertMode.Messages.NoData':
    'Es werden aktuell nicht alle Daten der Smart Battery zur Verfügung gestellt.',
  'Web.ExpertMode.Sections.Battery': 'Smart Battery',
  'Web.ExpertMode.Sections.Power': 'Wirkleistung',
  'Web.ExpertMode.Serial': 'Seriennummer:',
  'Web.forgot_password_error_user_not_found': 'Die angegebene E-Mail ist nicht registriert.',
  'Web.ForgotPassword.Buttons.Submit': 'Bestätigungscode zusenden',
  'Web.ForgotPassword.ContactDescription':
    'Falls Sie Ihre E-Mail-Adresse ebenfalls vergessen haben, kontaktieren Sie bitte den Siemens Service.',
  'Web.ForgotPassword.Description':
    'Bitte geben Sie Ihre E-Mail-Adresse ein, damit wir Ihnen den Bestätigungscode zum Zurücksetzen Ihres Passwortes zusenden können.',
  'Web.ForgotPassword.Password.Placeholder': 'Passwort',
  'Web.ForgotPassword.RepeatPassword.Placeholder': 'Passwort wiederholen',
  'Web.ForgotPassword.Title': 'Passwort zurücksetzen',
  'Web.chart_battery_money_earned': 'gespart',
  'Web.chart_battery_co2_saved': 'gespart',
  'Web.history_charts_today_with_date': 'Heute',
  'Web.History.AggregationPeriod.Day': 'Tag',
  'Web.History.AggregationPeriod.Month': 'Monat',
  'Web.History.AggregationPeriod.Week': 'Woche',
  'Web.History.AggregationPeriod.Year': 'Jahr',
  'Web.History.Authonomy.Legend.Authonomy': 'gesamt Autarkie',
  'Web.History.Authonomy.Legend.Battery': 'Anteil Batterie',
  'Web.History.Authonomy.Legend.Solar': 'Anteil PV-Anlage',
  'Web.History.Authonomy.Title': 'Durchschnittliche <br>Autarkie',
  'Web.History.Battery.Title': 'Durchschnittliche <br>Batterieladung',
  'Web.History.Consumption.Legend.Battery': 'Von der Batterie',
  'Web.History.Consumption.Legend.Grid': 'Aus dem Netz',
  'Web.History.Consumption.Legend.PV': 'Von der PV-Anlage',
  'Web.History.Consumption.Title': 'Gesamtverbrauch',
  'Web.History.SolarGeneration.Title': 'Solarerzeugung',
  'Web.History.chart_tooltip_solar_battery': 'In die Batterie',
  'Web.History.chart_tooltip_solar_direct_consumption': 'Direkter Verbrauch',
  'Web.History.chart_tooltip_solar_grid': 'In das Netz',
  'Web.History.Messages.NoData': 'Keine Daten für den ausgewählten Zeitraum vorhanden.',
  'Web.History.Title': 'Verlauf',
  'Web.history_chart_clicked_send_email': 'E-Mail wird gesendet...',
  'Web.history_email_failed':
    'Es konnte keine E-Mail mit den angeforderten Daten an Ihren Account geschickt werden.',
  'Web.history_email_sent_success': 'Die ausgewählten Daten wurden Ihnen per E-Mail zugesendet.',
  'Web.Hotline.Text': 'Montag bis Freitag von 8:00 bis 17:00 Uhr',
  'Web.Hotline.Title': 'Siemens Hotline',
  Web: {
    imprint: {
      address: {
        city: '80333 München Deutschland',
        name: 'Siemens Aktiengesellschaft',
        street: 'Werner-von-Siemens-Straße 1',
        title: 'Konzernzentrale'
      },
      board: 'Vorstand',
      chairman: 'Aufsichtsratvorsitzender',
      company: {
        address: 'Berlin und München, Deutschland',
        title: 'Sitz der Gesellschaft'
      },
      currentUpdate: {
        date: 'Stand vom 21.09.2017',
        leadTo: 'hier',
        text: 'Die aktuelle Version finden Sie'
      },
      identificationNr: 'Umsatzsteuer-Identifikationsnummer',
      register: {
        address: 'Berlin-Charlottenburg, HRB 12300München, HRB 6684',
        title: 'Registergericht'
      },
      responsible: {
        city: '80333 München Deutschland',
        name: 'Siemens Aktiengesellschaft Communications',
        street: 'Werner-von-Siemens-Straße 1',
        title: 'Verantwortlicher gemäß § 55 Abs. 2 RStV'
      },
      title: 'Impressum'
    }
  },
  'Web.Items.Battery.Title': 'Batterie',
  'Web.LegalDocuments.Buttons.Accept': 'Akzeptieren',
  'Web.LegalDocuments.Buttons.Decline': 'Ablehnen',
  'Web.Login.Header': 'Willkommen bei <br> Siemens Junelight',
  'Web.Login.Email': 'E-mail',
  'Web.Overview.Authonomy': 'Autarkie',
  'Web.Overview.Battery': 'Batterie',
  'Web.Overview.DisplayableItem.Buy': 'Beziehen',
  'Web.Overview.DisplayableItem.Charge': 'Laden',
  'Web.Overview.DisplayableItem.Consume': 'Verbrauchen',
  'Web.Overview.DisplayableItem.Discharge': 'Entladen',
  'Web.Overview.DisplayableItem.KilowattPerHour': 'kWh',
  'Web.Overview.DisplayableItem.Sell': 'Einspeisen',
  'Web.Overview.DisplayableItem.Sold': 'Verkauft',
  'Web.Overview.Expenses': 'Gekauft',
  'Web.Overview.Produce': 'Erzeugen',
  'Web.Overview.Title': 'Übersicht',
  'Web.Overview.Today': 'Heute',
  'Web.percentage': '%',
  'Web.percentage_with_value': '%1$s%%',
  'Web.placeholder_with_empty_string': '',
  'Web.placeholder_empty_string': ' ',
  'Web.system_electricity_price': 'Strompreis',
  'Web.system_electricity_price_error': 'Wert muss zwischen {0} und {1} liegen.',
  'Web.system_electricity_price_per_kw': 'Preis pro kWh',
  'Web.system_electricity_price_saved': 'Der Strompreis wurde auf {0} pro kWh festgelegt.',
  'Web.system_electricity_price_per_kw_button': 'Speichern',
  'Web.profile_error_change_profile_failed':
    'Ihr Profil konnte aufgrund von Server Problemen nicht gespeichert werden.',
  'Web.Profile.Buttons.Conditions': 'Nutzungsbedingungen',
  'Web.Profile.Buttons.Edit': 'Profil bearbeiten',
  'Web.Profile.Buttons.Imprint': 'Impressum',
  'Web.Profile.Buttons.Logout': 'Ausloggen',
  'Web.Profile.Buttons.OpenSource': 'Open Source Software',
  'Web.Profile.Buttons.Privacy': 'Datenschutzerklärung',
  'Web.Profile.Contakt': 'Kontakt',
  'Web.Profile.Copyright': '© Siemens AG, 2018',
  'Web.Profile.Email': 'E-Mail Adresse',
  'Web.Profile.Service': 'Service',
  'Web.Profile.Title': 'Profil',
  'Web.register_error_invalid_email': 'Geben Sie bitte eine valide E-Mail-Adresse ein.',
  'Web.register_error_invalid_password':
    'Ihr Passwort beinhaltet nicht alle nötigen Zeichen. Bitte versuchen Sie es erneut.',
  'Web.register_error_passwords_do_not_match':
    'Ihre Passwortangaben stimmen nicht überein. Bitte versuchen Sie es erneut.',

  'Web.Registration.Buttons.Register': 'Registrieren',
  'Web.Registration.DataUsage': 'Siemens darf meine persönlichen Daten zu Werbezwecken nutzen.',
  'Web.Registration.Email': 'E-Mail Adresse',
  'Web.Registration.FirstName': 'Name',
  'Web.Registration.Input.FirstName': 'Geben Sie bitte einen Vornamen ein.',
  'Web.Registration.Input.LastName': 'Geben Sie bitte einen Nachnamen ein.',
  'Web.Registration.LastName': 'Nachname',
  'Web.Registration.Legal.Text':
    'Durch Ihre Registrierung akzeptieren Sie die {0} und {1} von Siemens.',
  'Web.Registration.Password': 'Passwort',
  'Web.Registration.RepeatPassword': 'Passwort wiederholen',
  'Web.Registration.Title': 'Registrierung',

  'Web.ResetPassword.Code': 'Bestätigungscode',
  'Web.ResetPassword.Description':
    'Bitte geben Sie den Bestätigungscode, der Ihnen per E-Mail zugeschickt wurde, und Ihr neues Passwort ein.',
  'Web.service_handover_success_header': 'Hinweis',
  'Web.ServiceMode.Buttons.Request': 'Freischaltung beantragen',
  'Web.ServiceMode.Buttons.withdraw': 'Widerrufen',
  'Web.ServiceMode.Description':
    'Sie können einer weiteren Person Zugriff auf Ihre Smart Battery gewähren. Dies ist z.B. nötig, damit Ihr Techniker Servicearbeiten durchführen kann. Geben Sie dafür die E-Mail-Adresse der betreffenden Person ein. Die Freischaltung ist ab dem Zeitpunkt der Beantragung gültig, bis diese widerrufen wird.',
  'Web.ServiceMode.Errors.400':
    'Ein unerwartetes Problem ist aufgetreten. Prüfen Sie die korrekte Schreibweise der E-Mail-Adresse des Technikers oder versuchen Sie es später noch einmal.',
  'Web.ServiceMode.Errors.401':
    'Die Freischaltung konnte nicht erfolgreich durchgeführt werden, da Sie nicht die benötigte Berechtigung besitzen. Berechtigt sind nur Eigentümer einer Smart Battery.',
  'Web.ServiceMode.Errors.403':
    'Die Freischaltung konnte nicht erfolgreich durchgeführt werden, da ihr Nutzer-Account nicht verifiziert werden konnten. Bitte melden Sie sich erneut in der Anwendung an.',
  'Web.ServiceMode.Errors.404':
    'Die Freischaltung konnte nicht erfolgreich durchgeführt werden. Überprüfen Sie die korrekte Schreibweise der E-Mail-Adresse und versuchen Sie es erneut. Falls dies nicht erfolgreich ist, wenden Sie sich an den SIEMENS Service.',
  'Web.ServiceMode.Errors.500':
    'Aufgrund von Serverproblemen ist dieser Vorgang zurzeit nicht möglich. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
  'Web.ServiceMode.Messages.Success':
    'Freischaltung erfolgreich beantragt. Der freigegebene Nutzer kann ab sofort auf Ihre Smart Battery zugreifen.',
  'Web.ServiceMode.Title': 'Servicemodus',
  'Web.service_mode_list':
    'Folgende Nutzer haben Zugriff auf Ihre Smart Battery. Sie können den Zugriff zu jeder Zeit rückgängig machen.',
  'Web.service_mode_list_error':
    'Ein unerwartetes Problem ist aufgetreten. Versuchen Sie es später noch einmal.',
  'Web.service_mode_revoke_fail':
    'Der Zugriff auf die Smart Battery für {0} konnte nicht entzogen werden. Versuchen Sie es später noch einmal.',
  'Web.service_mode_revoke_success': '{0} hat nun keinen Zugriff mehr auf Ihre Smart Battery.',
  'Web.system_button_system_list': 'Systemliste',
  'Web.System.Battery': 'Batteriestatus',
  'Web.System.BatteryState.Error': 'Störung',
  'Web.System.BatteryState.Ok': 'Betriebsbereit',
  'Web.System.BatteryState.Problem': 'Offline',
  'Web.System.Buttons.ExpertMode': 'Expertenansicht',
  'Web.System.Cycles': 'Ladezyklen',
  'Web.System.Headline': 'Junelight Smart Battery',
  'Web.System.Title': 'System',
  'Web.System.TotalCapacity': 'Kapazität',
  'Web.unit_kilo_watt_pico': 'kWp',
  'Web.unit_kw': 'kW',
  'Web.unit_solo_kw': 'kW',
  'Web.unit_seconds': 's',
  'Web.unit_seconds_with_value': '%1$ss',
  'Web.unit_variable': 'var',
  'Web.unit_W': 'W',
  'Web.unit_with_space_amper': ' A',
  'Web.unit_with_space_kilo_watt_hour': ' kWh',
  'Web.unit_with_space_voltage': ' V',
  'Web.unit_with_space_watt': ' W',
  'Web.Validation.Password.Lenght': 'min. 8, max. 32 Zeichen',
  'Web.Validation.Password.Number': 'min. eine Zahl',
  'Web.Validation.Password.SpecialLetter':
    'min. ein Sonderzeichen aus ^ $ * . [] { } ( ) ? - " ! @ # % & / \\\\ , > < \' : ; | _ ~ `',
  'Web.Validation.Password.UppercaseLetter': 'min. ein Großbuchstabe',
  'Web.Validation.RepeatPassword.Mismatch': 'Ihre Passwort Angaben stimmen nicht überein',
  'Web.Verification.Buttons.Confirm': 'Bestätigen',
  'Web.Verification.Buttons.Resend': 'Verifikationscode erneut senden',
  'Web.Verification.Description':
    'Sie finden den Verifikationscode in der Ihnen zugesendeten E-Mail. Dieser Vorgang kann einige Momente dauern, bitte haben Sie etwas Geduld.',
  'Web.Verification.Messages.Failure':
    'Dieser Bestätigungscode stimmt nicht mit der dazu gehörigen E-Mail-Adresse überein. Bitte versuchen Sie es erneut. Falls dieser Fehler weiterhin auftritt wenden Sie sich bitte an den Service für Hilfe.',
  'Web.Percentage': '%',
  'Web.expert_view_smart_home_options': 'Smart Home',
  'Web.expert_view_smart_home_provider': 'Anbieter',
  'Web.expert_view_smart_home_none': 'Keiner',
  'Web.expert_view_smart_home_loxone': 'Loxone',
  'Web.expert_view_smart_home_knx': 'KNX',
  'Web.expert_view_smart_home_knx_ip_port': 'KNX IP-Adresse:Port',
  'Web.expert_view_smart_home_knx_device_id': 'KNX Geräte-ID',
  'Web.expert_view_smart_home_junelight_ip': 'Junelight IP-Adresse',
  'Web.expert_view.smart_home_knx_ip_port_hint': '0.0.0.0:0000',
  'Web.expert_view_limit_setup_switch': 'Wirkleistungsbegrenzung',
  'Web.expert_view_p_u_crtime_title': 'P(U)-Regelung Zeitkonstante',
  'Web.expert_view_wait_time_after_fail_title': 'Wartezeit nach Netzfehler',
  'Web.expert_view_voltage_dropout_title': 'Spannungsschutz Entkupplungsstelle U',
  'Web.expert_view_grid_protection_title': 'Netzkupplungsschutz',
  'Web.expert_view_power_reduction_title': 'Wirkleistungsreduktion bei Überfrequenz',

  'Web.expert_view_trip_time_ueff': 'Auslösezeit für Ueff',
  'Web.expert_view_voltage_protection_low_ueff': 'Unterspannungsschutz Ueff',
  'Web.expert_view_voltage_protection_ueff': 'Spannungs schutz Ueff',
  'Web.expert_view_monitoring_ueff': 'Überwachungsschutz Ueff',
  'Web.expert_view_f_derate': 'LFSM-O',
  'Web.expert_view_f_grad_reduc': 'Statik',

  'Web.expert_view_frequence_protection': 'Frequenzchutz f',
  'Web.expert_view_frequency_decrease_protection': 'Frequenzrückgangsschutz f&lt;',
  'Web.expert_view_frequency_increase_protection': 'Frequenzsteigerungsschutz f&gt;',
  'Web.expert_view_tor_toggle_title': 'Wechselrichter Schutzfunktionen',

  'Web.expert_view_news_title': 'Neuigkeiten',
  'Web.Profile.Buttons.News': 'Neuigkeiten',

  'Web.Overview.DisplayableItem.StandBy': 'Stand by',

  /** Authenticator */

  // Confirm Signup
  'Web.Authenticator.signUp.UserLambdaValidationException':
    'Sie haben sich bereits erfolgreich registriert. Bitte verifizieren Sie Ihren Account. Sie finden den Verifikationscode in der Ihnen zugesendeten E-Mail. Die erneute Zusendung eines Verifikationscode ist über den Login möglich.',

  'Web.Authenticator.confirmSignUp.NotAuthorizedException':
    'Der Bestätigungscode ist abgelaufen. Bitte lassen Sie ihn sich erneut zusenden.',

  'Web.Authenticator.confirmSignUp.CodeMismatchException':
    'Dieser Bestätigungscode stimmt nicht mit der dazu gehörigen E-Mail Adresse überein. Bitte versuchen Sie es erneut. Falls dieser Feheler weiterhin auftritt wenden Sie sich bitte an den Service für Hilfe.',

  //Forgot password
  'Web.Authenticator.passwordForgotten.default':
    'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  'Web.Authenticator.passwordForgotten.UserNotFoundException':
    'Die angegebene E-Mail ist nicht registriert.',
  'Web.Authenticator.passwordForgotten.CodeMismatchException':
    'Der Bestätigungscode ist abgelaufen. Bitte lassen Sie ihn sich erneut zusenden.',
  'Web.Authenticator.passwordForgotten.ExpiredCodeException':
    'Der Bestätigungscode ist abgelaufen. Bitte lassen Sie ihn sich erneut zusenden.',
  /** /Authenticator */

  'Web.expert_view_cr_time_read': 'P(U)-Aussteuerzeit',
  'Web.expert_view_recon_time_read': 'Wartezeit nach Netzfehler',
  'Web.expert_view_voltage_dropout_hi': 'Spannungsschutz Entkupplungsstelle U>',
  'Web.expert_view_voltage_dropout_lo': 'Spannungsschutz Entkupplungsstelle U<',
  'Web.expert_view_u1_limit_hi': 'Spannungsschutz Ueff>>',
  'Web.expert_view_u2_limit_lo': 'Spannungsschutz Ueff<<',
  'Web.expert_view_u1_time_hi': 'Auslösezeit für Ueff>>',
  'Web.expert_view_u2_time_lo': 'Auslösezeit für Ueff<<',
  'Web.expert_view_f1_limit_hi': 'Frequenzschutz f>',
  'Web.expert_view_f1_limit_lo': 'Frequenzschutz f<',
  'Web.expert_view_u1_limit_lo': 'Überwachungsschutz Ueff<',
  'Web.expert_view_u1_time_lo': 'Auslösezeit für Ueff<',
  'Web.expert_view_u_ave_hi': 'Überwachungsschutz Ueff>',
  'Web.expert_view_deraring_lsfm_o': 'LFSM-O',
  'Web.expert_view_derating_static': 'Statik',

  'Web.expert_view_tor_read_title': 'TOR Erzeuger Parameter',

  'Web.expert_view_pv_inverter_ip_type': '',

  'Web.unit.hertz': 'Hz',

  'Web.expert_view_heating_element_title': 'Heizstab',
  'Web.expert_view_heating_element_slider': 'Überschussleistung',
  'Web.expert_view_heating_element_switch': 'Heizstab über D2 angeschlossen',

  'Web.chartAutarky.title': '',
  'Web.chartAutarky.desc': '',

  'Web.disclaimer.text':
    'Diese Webseite wird nach dem 30.05.2021 nicht mehr unterstützt. Laden Sie sich bitte die Junelight App kostenlos für Ihr iOS oder Android Mobilgerät herunter.'
};
